import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthToken = () => localStorage.getItem('token');

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`,
  },
});

// payload: { scheduled_time (ISO), template_id?, recipients:[{lead_id,to_number,body,recipient_name?}] }
//   - also accepts a single recipient at the top level
export const createScheduledMessage = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/scheduled-messages`, payload, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error scheduling message:', error);
    throw error;
  }
};

// params: { status?, upcoming?, lead_id?, limit?, offset? }
export const listScheduledMessages = async (params = {}) => {
  try {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    ).toString();
    const response = await axios.get(`${API_URL}/scheduled-messages${qs ? `?${qs}` : ''}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching scheduled messages:', error);
    throw error;
  }
};

export const getScheduledMessage = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/scheduled-messages/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching scheduled message:', error);
    throw error;
  }
};

// data: { body?, scheduled_time? }
export const updateScheduledMessage = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/scheduled-messages/${id}`, data, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error updating scheduled message:', error);
    throw error;
  }
};

export const cancelScheduledMessage = async (id) => {
  try {
    const response = await axios.post(`${API_URL}/scheduled-messages/${id}/cancel`, {}, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error cancelling scheduled message:', error);
    throw error;
  }
};

export const deleteScheduledMessage = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/scheduled-messages/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error deleting scheduled message:', error);
    throw error;
  }
};
